import { Card, message } from "antd";
import React, { useState } from "react";
import HButton from "../../../components/custom/input/button/Button";
import { useVoiceContext } from "../../context/VoiceContext";
import { handleStatusChange, voiceAgentMode, voiceAgentStatus } from "../../utils/VoiceUtils";
import useHttp from "../../../hooks/useHttp";
import { useContext } from "react";
import { AppContext } from "../../../context/AppContext";
function OverThePhoneInfoComponent(props) {
  const [callProperties, setCallProperties] = useVoiceContext();
  let { setShowOfflineMessageWhileInit, voiceIntegId } = props;

  const [buttonLoading, setButtonLoading] = useState(false);
  const { fetchData } = useHttp();
  const [appProperties] = useContext(AppContext);
  let leftServiceId = appProperties?.leftServiceId;
  const goOnline = () => {
    setButtonLoading(true);
    handleStatusChange(
      voiceAgentStatus.ONLINE_WEB,
      voiceAgentMode.OVER_THE_WEB,
      leftServiceId,
      appProperties,
      voiceIntegId,
      fetchData,
      setCallProperties,
      setShowOfflineMessageWhileInit
    ).then(function (res) {
      const statusValue = res?.data?.voiceAgentStatusEntity?.voiceAgentStatus;
      const errorMessage = res?.data?.errorMessage;
      if (statusValue === voiceAgentStatus.ONLINE_WEB) {
        setShowOfflineMessageWhileInit(false);
        setCallProperties((prev) => ({
          ...prev,
          focusToNumberField: "visible",
        }));
      } else {
        message.error(errorMessage);
        setCallProperties((prev) => ({
          ...prev,
          focusToNumberField: "hidden",
        }));
      }
      setButtonLoading(false);
    });
  };

  return (
    <div className="hs-h-80 overflow-hidden w-100">
      <div className="hs-h-80 d-flex justify-content-center align-items-center">
        <Card
          style={{
            width: 300,
            background: "none",
            border: "1px solid #374151",
          }}
        >
          <div className="w-100 d-flex justify-content-center hs-h-20">
            <div className={`call-action-icons cursor-pointer over-the-phone-info-icon`} />
          </div>
          <div className="w-100 d-flex justify-content-center hs-h-7">
            <span className="customer-in-offline-message text-white">
              <>You're in 'Over the Phone' mode.</>
            </span>
          </div>
          <div className="w-100 d-flex justify-content-center hs-h-7">
            <span className="customer-in-offline-message-secondary">
              {" "}
              <>To attend or make calls via browser, Please switch to 'Over the Web' mode.</>{" "}
            </span>
          </div>

          <>
            <div className="w-100 d-flex justify-content-center hs-h-60">
              <HButton
                loading={buttonLoading}
                onClick={goOnline}
                size="md"
                buttonClassName={"hs-w-fit mt-3 fw-bold"}
                style={{
                  background: "#605BFF",
                }}
              >
                <div className="d-flex flex-row align-items-center">
                  <div className="call-action-icons over-the-web-white-icon"></div>
                  <div>Switch to Web</div>
                </div>
              </HButton>
            </div>
          </>
        </Card>
      </div>
    </div>
  );
}

export default OverThePhoneInfoComponent;
